import React from "react";

import type { ReportStrategyPineFields } from "../../types/reportStrategyPine";
import type { PineUxCopy } from "../../utils/pineIrUi";
import {
  buildStrategyPineEditorBadgeItems,
  PineBadgeList,
} from "../../views/Dashboard/Strategies/strategyTablePineBadges";

export type StrategyPineStatusBadgesProps = {
  fields: ReportStrategyPineFields | null | undefined;
  subtleText?: string;
  showMeta?: boolean;
  parseStatusUx?: Record<string, PineUxCopy> | null;
  injectReadinessUx?: Record<string, PineUxCopy> | null;
  exitHookReadinessUx?: Record<string, PineUxCopy> | null;
};

export function StrategyPineStatusBadges({
  fields,
  showMeta = true,
}: StrategyPineStatusBadgesProps): React.ReactElement | null {
  if (!fields || !showMeta) {
    return null;
  }

  const items = buildStrategyPineEditorBadgeItems(fields);
  if (items.length === 0) {
    return null;
  }

  return (
    <div data-strategy-pine-status-badges="">
      <PineBadgeList items={items} />
    </div>
  );
}
